import Axios from 'axios';

export let instanciaAxios = Axios.create({
  baseURL: process.env.VUE_APP_URL_BASE_BACKEND,
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json'
  }
})

export default {

  obtenerDatosDeParkings() {
    return instanciaAxios.get(`/obtenerDatos`);
  },

  obtenerTiempo() {
    Axios.get('https://fcc-weather-api.glitch.me/api/current?lat=40.4165&lon=-3.70256')
      .then((res) => {
        return res;
      })
  },

  obtenerPlazasDisponibles(matricula, entrada, salida, parking) {
    return instanciaAxios.get('/plazasDisponibles/' + matricula + '/' + entrada + '/' + salida + "/" + parking);
  },

  obtenerParkings() {
    return instanciaAxios.get('/obtenerDatosParkings');
  },
  enviarCurriculum(nombre, apellidos, telefono, archivob64, nombreArchivo) {
    let peticion = {}
    peticion.nombre = nombre
    peticion.apellidos = apellidos
    peticion.telefono = telefono
    peticion.archivob64 = archivob64
    peticion.nombreArchivo = nombreArchivo

    return instanciaAxios.post('/enviarCurriculum', peticion);
  },

  nuevaReserva(peticion) {
    return instanciaAxios.post('/nuevaReservaBD', peticion);
  },

  obtenerUrlPago(peticion) {
    return instanciaAxios.post('/obtenerURLdePago', peticion);
  },

  obtenerReserva(peticion) {
    return instanciaAxios.post('/obtenerReserva', peticion);
  },

  buscarReserva(peticion) {
    return instanciaAxios.post('/buscarReserva', peticion);
  },

  generarFactura(peticion) {
    return instanciaAxios.post('/generarFactura', peticion);
  },

  cancelarReserva(peticion) {
    return instanciaAxios.put('/cancelarReserva', peticion);
  },

  reserva(merchant) {
    return instanciaAxios.get('/reserva/'+merchant)
  },

  verificarValidezCodigoPromocional(codigo, entrada, salida, parking) {
    return instanciaAxios.get('verificarCodigo/' + codigo + '/' + entrada + '/' + salida + '/' + parking);
  },

  verificarCodigoPromocional(datos) {
    return instanciaAxios.post('verificarCodigoPromocional', datos);
  },

  //Obtenemos los terminos y condiciones
  obtenerTerminosYCondicones(tipoPagina, idioma) {
    return instanciaAxios.get('/obtenerTerminos/' + tipoPagina + '/' + idioma);
  }
}
